import { useSearchParams } from "react-router-dom";
import BookingForm from "../components/BookingForm";

const serviceMap = {
  "6-weeks-2-years": "6 WEEKS - 2 YEARS",
  "2-3-years": "2 - 3 YEARS",
  "3-12-years": "3 - 12 YEARS",
  "3-5-years": "3 - 5 YEARS",
};

const BookingPage = () => {
  const [searchParams] = useSearchParams();
  const serviceParam = searchParams.get("service");
  const typeParam = searchParams.get("type") || "sherman-oaks";
  const promoParam = searchParams.get("promo") || "";
  const service = serviceMap[serviceParam] || "6 WEEKS - 2 YEARS";

  return (
    <div>
      <BookingForm service={service} type={typeParam} promo={promoParam} />
    </div>
  );
};

export default BookingPage;
